export default __webpack_public_path__ + "img/ciNRJXia.e04f0336.svg";